export default __webpack_public_path__ + "static/media/films.0b5930fd.webp";